export const MobileIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.25927 6.75918C6.93517 5.77674 8.2858 6.06248 8.91291 7.07685L9.79901 8.51015C10.0617 8.93502 9.99793 9.48501 9.64506 9.83835L9.29681 10.1871C8.87685 10.6076 8.87685 11.2894 9.29681 11.7099L12.9087 15.3266C13.3287 15.7471 14.0096 15.7471 14.4295 15.3266L14.7701 14.9856C15.1265 14.6288 15.6826 14.5676 16.1078 14.8386L17.7625 15.893C18.7588 16.5278 19.0345 17.8677 18.0651 18.5432C16.3498 19.7384 13.1884 20.5558 8.72651 16.088C4.2838 11.6394 5.07411 8.48184 6.25927 6.75918Z"
        stroke="#222530"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
